import * as ambassadorWixWorkflowsV1Workflow from './workflows-v1-workflow-workflows.http.js';
import * as ambassadorWixWorkflowsV1WorkflowTypes from './workflows-v1-workflow-workflows.types.js';
import * as ambassadorWixWorkflowsV1WorkflowUniversalTypes from './workflows-v1-workflow-workflows.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listWorkflows(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.ListWorkflowsRequest,
  ambassadorWixWorkflowsV1WorkflowTypes.ListWorkflowsRequest,
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.ListWorkflowsResponse,
  ambassadorWixWorkflowsV1WorkflowTypes.ListWorkflowsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixWorkflowsV1Workflow.listWorkflows(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/workflows',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getWorkflow(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.GetWorkflowRequest,
  ambassadorWixWorkflowsV1WorkflowTypes.GetWorkflowRequest,
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.GetWorkflowResponse,
  ambassadorWixWorkflowsV1WorkflowTypes.GetWorkflowResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixWorkflowsV1Workflow.getWorkflow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/workflows/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateWorkflow(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string },
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.UpdateWorkflowRequest,
  ambassadorWixWorkflowsV1WorkflowTypes.UpdateWorkflowRequest,
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.UpdateWorkflowResponse,
  ambassadorWixWorkflowsV1WorkflowTypes.UpdateWorkflowResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixWorkflowsV1Workflow.updateWorkflow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/workflows/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createWorkflow(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.CreateWorkflowRequest,
  ambassadorWixWorkflowsV1WorkflowTypes.CreateWorkflowRequest,
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.CreateWorkflowResponse,
  ambassadorWixWorkflowsV1WorkflowTypes.CreateWorkflowResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixWorkflowsV1Workflow.createWorkflow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/workflows',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteWorkflow(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.DeleteWorkflowRequest,
  ambassadorWixWorkflowsV1WorkflowTypes.DeleteWorkflowRequest,
  ambassadorWixWorkflowsV1WorkflowUniversalTypes.DeleteWorkflowResponse,
  ambassadorWixWorkflowsV1WorkflowTypes.DeleteWorkflowResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixWorkflowsV1Workflow.deleteWorkflow(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/workflows/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Workflow as WorkflowOriginal,
  WorkflowInfo as WorkflowInfoOriginal,
  Phase as PhaseOriginal,
  PhaseInfo as PhaseInfoOriginal,
  CardsList as CardsListOriginal,
  Card as CardOriginal,
  CardInfo as CardInfoOriginal,
  Attachment as AttachmentOriginal,
  AttachmentType as AttachmentTypeOriginal,
  AttachmentTypeWithLiterals as AttachmentTypeWithLiteralsOriginal,
  PhasesList as PhasesListOriginal,
  ListWorkflowsRequest as ListWorkflowsRequestOriginal,
  ListWorkflowsResponse as ListWorkflowsResponseOriginal,
  PaginationResponse as PaginationResponseOriginal,
  QueryWorkflowsRequest as QueryWorkflowsRequestOriginal,
  Query as QueryOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryWorkflowsResponse as QueryWorkflowsResponseOriginal,
  GetWorkflowRequest as GetWorkflowRequestOriginal,
  GetWorkflowResponse as GetWorkflowResponseOriginal,
  UpdateWorkflowRequest as UpdateWorkflowRequestOriginal,
  UpdateWorkflowResponse as UpdateWorkflowResponseOriginal,
  CreateWorkflowRequest as CreateWorkflowRequestOriginal,
  CreateWorkflowResponse as CreateWorkflowResponseOriginal,
  DeleteWorkflowRequest as DeleteWorkflowRequestOriginal,
  DeleteWorkflowResponse as DeleteWorkflowResponseOriginal,
  SetupWorkflowRequest as SetupWorkflowRequestOriginal,
  SetupWorkflowResponse as SetupWorkflowResponseOriginal,
} from './workflows-v1-workflow-workflows.types.js';
